import {createContext, type PropsWithChildren, useCallback, useContext, useId, useMemo, useRef} from "react";

import {useElementWasVisible} from "@pg-mono/hooks";

import {type PropertyViewSectionName, trackAmplitudePropertyViewSection} from "../../tracking/amplitude/track_amplitude_property_view_section";

interface IPropertyViewSectionTrackingContext {
    itemId: number;
    propertyId: number;
    trackedSections: Set<PropertyViewSectionName>;
}

interface IPropertyViewSectionTrackingProviderProps extends PropsWithChildren {
    itemId: number;
    propertyId: number;
}

interface IPropertyViewSectionTrackerProps {
    sectionName: PropertyViewSectionName;
}

const PropertyViewSectionTrackingContext = createContext<IPropertyViewSectionTrackingContext | null>(null);
const sectionHeadingSelector = "h1, h2, h3, h4, h5, h6";

const getSectionElement = (sentinel: HTMLSpanElement | null): Element | null => {
    let nextElement = sentinel?.nextElementSibling ?? null;

    while (nextElement?.hasAttribute("hidden")) {
        nextElement = nextElement.nextElementSibling;
    }

    const sectionElement = nextElement ?? sentinel?.parentElement ?? null;

    if (sectionElement === null) {
        return null;
    }

    return sectionElement.matches(sectionHeadingSelector) ? sectionElement : (sectionElement.querySelector(sectionHeadingSelector) ?? sectionElement);
};

export const PropertyViewSectionTrackingProvider = ({children, itemId, propertyId}: IPropertyViewSectionTrackingProviderProps) => {
    const trackingContext = useMemo<IPropertyViewSectionTrackingContext>(
        () => ({
            itemId,
            propertyId,
            trackedSections: new Set<PropertyViewSectionName>()
        }),
        [itemId, propertyId]
    );

    return <PropertyViewSectionTrackingContext.Provider value={trackingContext}>{children}</PropertyViewSectionTrackingContext.Provider>;
};

export const PropertyViewSectionTracker = ({sectionName}: IPropertyViewSectionTrackerProps) => {
    const trackingContext = useContext(PropertyViewSectionTrackingContext);
    const trackerInstanceId = useId().replace(/[^a-zA-Z0-9_-]/g, "");
    const trackedElementRef = useRef<Element | null>(null);
    const trackingElementId =
        trackingContext === null ? null : `property-view-section-${trackingContext.itemId}-${trackingContext.propertyId}-${sectionName}-${trackerInstanceId}`;

    const setSentinelRef = useCallback((sentinel: HTMLSpanElement | null) => {
        trackedElementRef.current = getSectionElement(sentinel);
    }, []);

    const handleElementVisible = useCallback(
        (_id: string, entry: IntersectionObserverEntry) => {
            if (trackingContext === null || entry.intersectionRatio < 0.5 || trackingContext.trackedSections.has(sectionName)) {
                return;
            }

            trackingContext.trackedSections.add(sectionName);
            trackAmplitudePropertyViewSection({
                sectionName,
                itemId: trackingContext.itemId,
                propertyId: trackingContext.propertyId
            });
        },
        [sectionName, trackingContext]
    );

    useElementWasVisible({
        ids: [],
        elementRefs: trackingElementId === null ? [] : [{id: trackingElementId, ref: trackedElementRef}],
        onElementVisible: handleElementVisible,
        once: false,
        threshold: 0.5,
        disabled: trackingElementId === null
    });

    return <span ref={setSentinelRef} hidden aria-hidden="true" />;
};
import {createContext, type PropsWithChildren, useCallback, useContext, useId, useMemo, useRef} from "react";

import {useElementWasVisible} from "@pg-mono/hooks";

import {type PropertyViewSectionName, trackAmplitudePropertyViewSection} from "../../tracking/amplitude/track_amplitude_property_view_section";

interface IPropertyViewSectionTrackingContext {
    itemId: number;
    propertyId: number;
    trackedSections: Set<PropertyViewSectionName>;
}

interface IPropertyViewSectionTrackingProviderProps extends PropsWithChildren {
    itemId: number;
    propertyId: number;
}

interface IPropertyViewSectionTrackerProps {
    sectionName: PropertyViewSectionName;
}

const PropertyViewSectionTrackingContext = createContext<IPropertyViewSectionTrackingContext | null>(null);
const sectionHeadingSelector = "h1, h2, h3, h4, h5, h6";

const getSectionElement = (sentinel: HTMLSpanElement | null): Element | null => {
    let nextElement = sentinel?.nextElementSibling ?? null;

    while (nextElement?.hasAttribute("hidden")) {
        nextElement = nextElement.nextElementSibling;
    }

    const sectionElement = nextElement ?? sentinel?.parentElement ?? null;

    if (sectionElement === null) {
        return null;
    }

    return sectionElement.matches(sectionHeadingSelector) ? sectionElement : (sectionElement.querySelector(sectionHeadingSelector) ?? sectionElement);
};

export const PropertyViewSectionTrackingProvider = ({children, itemId, propertyId}: IPropertyViewSectionTrackingProviderProps) => {
    const trackingContext = useMemo<IPropertyViewSectionTrackingContext>(
        () => ({
            itemId,
            propertyId,
            trackedSections: new Set<PropertyViewSectionName>()
        }),
        [itemId, propertyId]
    );

    return <PropertyViewSectionTrackingContext.Provider value={trackingContext}>{children}</PropertyViewSectionTrackingContext.Provider>;
};

export const PropertyViewSectionTracker = ({sectionName}: IPropertyViewSectionTrackerProps) => {
    const trackingContext = useContext(PropertyViewSectionTrackingContext);
    const trackerInstanceId = useId().replace(/[^a-zA-Z0-9_-]/g, "");
    const trackedElementRef = useRef<Element | null>(null);
    const trackingElementId =
        trackingContext === null ? null : `property-view-section-${trackingContext.itemId}-${trackingContext.propertyId}-${sectionName}-${trackerInstanceId}`;

    const setSentinelRef = useCallback((sentinel: HTMLSpanElement | null) => {
        trackedElementRef.current = getSectionElement(sentinel);
    }, []);

    const handleElementVisible = useCallback(
        (_id: string, entry: IntersectionObserverEntry) => {
            if (trackingContext === null || entry.intersectionRatio < 0.5 || trackingContext.trackedSections.has(sectionName)) {
                return;
            }

            trackingContext.trackedSections.add(sectionName);
            trackAmplitudePropertyViewSection({
                sectionName,
                itemId: trackingContext.itemId,
                propertyId: trackingContext.propertyId
            });
        },
        [sectionName, trackingContext]
    );

    useElementWasVisible({
        ids: [],
        elementRefs: trackingElementId === null ? [] : [{id: trackingElementId, ref: trackedElementRef}],
        onElementVisible: handleElementVisible,
        once: false,
        threshold: 0.5,
        disabled: trackingElementId === null
    });

    return <span ref={setSentinelRef} hidden aria-hidden="true" />;
};
